import React from "react";

import { Brand } from "custom-types/Brand";
import { MenuItem } from "custom-types/MenuItem";

import Carousel from "components/botanic/Carousel";
import MenuItemCard from "components/botanic/MenuItemCard";
import BagIcon from "components/Icons/bag.svg";
import { MenuItemCardActions } from "components/Shared/MenuItemCarousel/MenuItemCardActions";

type Props = {
  menuItems: MenuItem[];
  brand: Brand;
};
const ShopNearbySection: React.FC<Props> = ({ menuItems, brand }) => {
  /*
    Q: Why not using Shared/MenuItemCarousel?
    A: It's not quite what we need but could (probably) be updated.
       The big issue is that this goes near top of BPP,
       so we preload the menu items with page to avoid any layout shift up top.
       A group of animated skelements just vanishing would look crappy.
  */
  const cards = menuItems.map((menuItem) => (
    <MenuItemCard key={menuItem.id} menuItem={menuItem} showFulfillment={true}>
      <MenuItemCardActions
        menuItem={menuItem}
        splitClickEventName="brands_addToBagClick_frontend"
      />
    </MenuItemCard>
  ));

  if (!menuItems.length) {
    return <></>;
  }
  return (
    <section>
      <div className="py-xxl">
        {/**
         * Remove the padding below the carousel to allow the margin above the
         * button to dictate the spacing between the two elements.
         */}
        <div className="-mb-md">
          <Carousel title="Featured menus near you">{cards}</Carousel>
        </div>
        <div className="mt-lg">
          <a
            href={`/search/shop?shopCategory=brand&shopName=${encodeURIComponent(
              brand.name
            )}`}
            className="button button--primary flex justify-center items-center flex-grow "
          >
            <BagIcon height="20" width="20" className="mr-sm" />
            shop all menus near you
          </a>
        </div>
      </div>
    </section>
  );
};

export default ShopNearbySection;
